// export const actions = {
//   async nuxtServerInit (_, { app }) {
//     console.log(app.i18n);
//   }
// };
export const mutations = {};
export const state = () => ({});
